import { storableError } from '../../util/errors';
import {
  deleteRewildingInfoFiles,
  getRewildingInfoFiles,
  uploadRewildingInfoFiles,
} from '../../util/api';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const FETCH_FILES_REQUEST = 'app/RewildingInfoPage/FETCH_FILES_REQUEST';
export const FETCH_FILES_SUCCESS = 'app/RewildingInfoPage/FETCH_FILES_SUCCESS';
export const FETCH_FILES_ERROR = 'app/RewildingInfoPage/FETCH_FILES_ERROR';
export const ADD_FILES = 'app/RewildingInfoPage/ADD_FILES';
export const REMOVE_FILE_REQUEST = 'app/RewildingInfoPage/REMOVE_FILE_REQUEST';
export const REMOVE_FILE_SUCCESS = 'app/RewildingInfoPage/REMOVE_FILE_SUCCESS';

// ================ Reducer ================ //

const initialState = {
  files: [],
  queryInProgress: false,
  queryFilesError: null,
  removeFileInProgress: false,
};

const rewildingInfoPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_FILES_REQUEST:
      return {
        ...state,
        queryInProgress: true,
        queryFilesError: null,
      };
    case FETCH_FILES_SUCCESS:
      return {
        ...state,
        files: payload,
        queryInProgress: false,
      };
    case FETCH_FILES_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, queryInProgress: false, queryFilesError: payload };
    case ADD_FILES: {
      const newFiles = [...state.files, ...payload];
      return { ...state, files: newFiles };
    }
    case REMOVE_FILE_REQUEST: {
      return { ...state, removeFileInProgress: true };
    }
    case REMOVE_FILE_SUCCESS: {
      const filteredFiles = state.files.filter(item => item.key !== payload);
      return {
        ...state,
        files: filteredFiles,
        removeFileInProgress: false,
      };
    }
    default:
      return state;
  }
};

export default rewildingInfoPageReducer;

// ================ Action creators ================ //

export const queryFilesRequest = () => ({
  type: FETCH_FILES_REQUEST,
});

export const queryFilesSuccess = payload => ({
  type: FETCH_FILES_SUCCESS,
  payload,
});

export const queryFilesError = e => ({
  type: FETCH_FILES_ERROR,
  error: true,
  payload: e,
});

export const addFiles = files => ({
  type: ADD_FILES,
  payload: files,
});

export const removeFileRequest = () => ({
  type: REMOVE_FILE_REQUEST,
});

export const removeFileSuccess = key => ({
  type: REMOVE_FILE_SUCCESS,
  payload: key,
});

// ================ Thunks ================ //

export const queryFiles = () => async (dispatch, getState, sdk) => {
  dispatch(queryFilesRequest());

  try {
    const response = await getRewildingInfoFiles();
    const { rewildingInfoFiles = [] } = response;
    dispatch(queryFilesSuccess(rewildingInfoFiles));
  } catch (e) {
    dispatch(queryFilesError(storableError(e)));
    throw e;
  }
};

export const requestAddFiles = ({ formData }) => async (dispatch, getState, sdk) => {
  try {
    const response = await uploadRewildingInfoFiles(formData);

    dispatch(addFiles(response));
  } catch (e) {
    log.error(e, 'upload-files-failed');
  }
};

export const requestRemoveFile = ({ key }) => async (dispatch, getState, sdk) => {
  try {
    dispatch(removeFileRequest());

    const state = getState();

    await deleteRewildingInfoFiles({
      keys: [key],
      userFlow: 'admin',
      userId: state.user.currentUser.id.uuid,
    });

    dispatch(removeFileSuccess(key));
  } catch (e) {
    log.error(e, 'delete-files-failed');
  }
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  return Promise.all([dispatch(fetchCurrentUser()), dispatch(queryFiles())]).catch(e => {
    throw e;
  });
};
